import { Row, Col } from 'react-grid-system';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Card from '../components/Card';
import FlexBox from '../components/FlexBox';

const SignOutCard = styled(Card)`
  text-align: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(90deg, rgb(71, 85, 105) 0%, rgb(50 60 75) 118.29%);
`;

function UnauthorizedPage() {
  return (
    <>
      <Row>
        <Col>
          <SignOutCard>
            <FlexBox
              direction="column"
              justify="center"
              style={{ height: '100%' }}
              space={3}
              alignItems="center">
              {/* <img src={LogoImage} alt="" style={{ marginBottom: '24px' }} /> */}

              <h2>Authorization error.</h2>
              <p>
                Please try again, or contact
                <a
                  style={{ padding: '0 5px 0 5px' }}
                  href="mailto:help@cmkl.ac.th">
                  help@cmkl.ac.th
                </a>
                for assistance.
              </p>
              <p>
                Need to get back in? <a style={{ color: 'yellow' }} href="/signin">Sign in again</a>.
              </p>
            </FlexBox>
          </SignOutCard>
        </Col>
      </Row>
    </>
  );
}

export default UnauthorizedPage;
